import { Observable, merge, Subscription } from 'rxjs';
import { map as mapEvent } from 'rxjs/operators';
import { Geodetic } from '../map/map-types'
import { Timeline, createTimeCursorObservable } from '../timeline/timeline';
import { LocationTime } from '../data-source/types';
import { Map } from '../map/map';
import { CursorMillis } from '../timeline/timeline-common';

export class LocationTimeMonitor {
	private subscription: Subscription = undefined;

	private location: Geodetic;
	private time: number;

	contructor() {
		this.location = undefined;
		this.time = undefined;
		this.subscription = undefined;
	}

	public monitor(map: Map, timeline: Timeline, handler: (locationTime: LocationTime) => void) {
		this.release();
		if (map && timeline) {
			//seed monitor with the position of the timecursor
			this.updateTime(timeline.getCursorMillis() ? timeline.getCursorMillis().center : undefined);

			let self = this;
			let locationTimeObservable: Observable<LocationTime> = merge(
				map.getObservable('mousemove').pipe(mapEvent( (evt:any) => self.updateLocation({ lat: evt.latLng.lat(), lng: evt.latLng.lng() }))),
				createTimeCursorObservable(timeline).pipe(mapEvent((evt: CursorMillis) => self.updateTime(evt ? evt.center : undefined)))
			)

			this.subscription = locationTimeObservable.subscribe({ next: handler } );
		}

	}

	public release() {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}

	public updateLocation(location: Geodetic): LocationTime {
		this.location = location;
		return this.get();
	}
	public updateTime(time: number): LocationTime {
		this.time = time;
		return this.get();
	}
	public get(): LocationTime {
		return (this.location != undefined && this.time != undefined) ? { location: this.location, time: this.time } : undefined;
	}
}